import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCity, faFlagUsa, faStar } from '@fortawesome/free-solid-svg-icons'

import { AdminTd, AdminTh, AdminTable } from '../Tables'

import clsx from 'clsx'
import Button from '../../utils/Button'

export const FacilityGroupsTable = ({ facilityGroups, actions }) => {
  return (
    <AdminTable>
      <thead>
        <tr>
          <AdminTh>X</AdminTh>
          <AdminTh>Name</AdminTh>
          <AdminTh>Facilities</AdminTh>
          <AdminTh>State</AdminTh>
          {actions && <AdminTh>Actions</AdminTh>}
        </tr>
      </thead>
      <tbody>
        {facilityGroups.map((obj, index) => (
          <tr
            key={index}
            className={clsx(obj.id && index % 2 !== 0 && 'bg-green-100', obj.outOfOrder && 'bg-red-100 bg-opacity-40')}
          >
            <AdminTd>
              <div className="flex space-x-1">
                {obj.featured && <FontAwesomeIcon icon={faStar} />}
                {obj.stateGroup && <FontAwesomeIcon icon={faFlagUsa} />}
                {obj.agencyId && <FontAwesomeIcon icon={faCity} />}
              </div>
            </AdminTd>
            <AdminTd>
              <div>
                <Link to={`/explore/${obj.slug}`}>{obj.name}</Link>
              </div>
              <div className="text-sm text-gray-400">{obj.id}</div>
            </AdminTd>
            <AdminTd>{obj.facilitiesActiveCount}</AdminTd>
            <AdminTd>{obj.state}</AdminTd>
            {actions && (
              <AdminTd>
                {actions.map(action => (
                  <Button key={action.label} color="darkGreen" size="xs" onClick={() => action.onClick(obj)}>
                    {action.label}
                  </Button>
                ))}
              </AdminTd>
            )}
          </tr>
        ))}
      </tbody>
    </AdminTable>
  )
}

export default FacilityGroupsTable
